// extracted by mini-css-extract-plugin
export var circle = "_x-2";
export var icon = "_x-a";
export var iconHighlight = "_x-0";
export var lg = "_x-8";
export var md = "_x-7";
export var outline = "_x-4";
export var sm = "_x-6";
export var square = "_x-1";
export var xl = "_x-9";
export var xs = "_x-5";
export var xxs = "_x-3";